export default {
  'tournament.hallId': '大厅ID',
  'tournament.hallName': '大厅名称',
  'tournament.initialChips': '初始筹码',
  'tournament.timeLimit': '时限',
  'tournament.playerLimit': '人限',
  'tournament.ticket': '门票',
  'tournament.game': '游戏',
  'tournament.matchMode': '比赛模式',
  'tournament.balance': '余额',
  'tournament.coverImage': '封面图',
  'tournament.createTime': '创建时间',
  'tournament.updateTime': '更新时间',
  'tournament.operation': '操作',
  'tournament.bonusTemplate': '奖金模板',
  'tournament.hallParameters': '大厅参数',
  'tournament.input': '输入',
  'tournament.hallNameTranslation': '大厅名称翻译',
  'tournament.prizePool': '奖金池',
  'tournament.robotParticipationSwitch': '机器参与开关',
  'tournament.hallType': '大厅类型',
  'tournament.bonusExchangeMethod': '奖金兑换方式',
  'tournament.exchangeCodeValidityPeriod': '兑换码有效时限',
  'tournament.bonusExchangeCopyTemplate': '奖金兑换文案模版',
  'tournament.globalConfig': '全局配置',
  'tournament.openGlobalConfig': '打开全局配置',
  'tournament.homeHallCardUITemplate': '首页大厅卡UI模版',
  'tournament.modify': '修改',
  'tournament.matchModeBetAmount': '比赛模式：投注额',
  'tournament.matchModeBalance': '比赛模式：余额',
  'tournament.language': '语言',
  'tournament.enterTranslation': '请输入{lang}翻译',
  'tournament.selectGame': '选游戏',
  'tournament.clickUpload': '点击上传',
  'tournament.bonusSettings': '奖金设置',
  'tournament.activeLobbies': '个大厅在开启',
  'tournament.chinese': '中文',
  'tournament.english': '英文',
  'tournament.tagalog': '菲文',
  'tournament.vietnamese': '越文',
  'tournament.submitLogic': '提交逻辑',
  'tournament.uploadImageTip': '只能上传jpg/png/webp/gif文件',
  'tournament.uploadErrorMsg': '只能上传jpg/png/jpeg/webp文件',
  'tournament.bonusTemplateSheet': '奖金模板',
  'tournament.templateFileName': '奖金设置模板.xlsx',
  'tournament.rankReference': '名次(仅参考)',
  'tournament.amount': '金额',
  'tournament.firstPlace': '第1名',
  'tournament.secondPlace': '第2名',
  'tournament.emptyTemplateError': '模板内容为空或格式不正确',
  'tournament.importSuccess': '成功导入',
  'tournament.playerCountMustBeGreaterThanZero': '人数必须大于0',
  'tournament.timeLimitMustBeGreaterThanZero': '时限必须大于0',
  'tournament.playerLimitMustBeGreaterThanZero': '人限必须大于0',
  'tournament.ticketMustBeGreaterThanZero': '门票必须大于0',
  'tournament.uploadImageRequired': '请上传图片',
  'tournament.enterSortNumber': '请输入排序数字',
  'tournament.downloadImportTemplate': '下载导入模板',
  'tournament.import': '导入',
  'tournament.addItem': '添加',
  'tournament.place': '第{num}名',
  'tournament.enterAmount': '请输入金额',
  'tournament.homeHallCardUITemplateTitle': '首页大厅卡UI模版:',
  'tournament.homeHallCardUITemplateLabel': '首页大厅卡UI模版',
  'tournament.matchRulesCopy': '比赛规则文案',
  'tournament.matchModeBetAmountTitle': '比赛模式：投注额',
  'tournament.matchModeBalanceTitle': '比赛模式：余额',
  'tournament.languageLabel': '语言',
  'tournament.enterLanguageTranslation': '请输入{lang}翻译',
  'tournament.specifyGame': '指定游戏',
  'tournament.selected': '已选',
  'tournament.minutes': '分钟',
  'tournament.people': '人',
  'tournament.tickets': '张',
  'tournament.prizePoolMustBeGreaterThanZero': '奖金池必须大于0',
  'tournament.enterHallName': '请输入大厅名称',
  'tournament.selectHallNameTranslation': '请选择大厅名称翻译',
  'tournament.redemptionCode': '兑换码',
  'tournament.days': '天',
  'tournament.hours': '小时',
  'tournament.daysRange': '0-365天',
  'tournament.open': '开启',
  'tournament.normal': '普通',
  'tournament.demo': '试玩',
  'tournament.cash': '现金',
  'tournament.hoursRange': '0-24小时',
  'tournament.minutesRange': '0-60分钟',
  'tournament.enterAccountToQuery': '输入账号查询之后才能进行门票设置',
  'tournament.existingTickets': '现有门票数',
  'tournament.operationType': '操作类型',
  'tournament.increase': '增加',
  'tournament.deduct': '扣除',
  'tournament.ticketChangeAmount': '变动门票数',
  'tournament.enterTicketChangeAmount': '请输入变动门票数',
  'tournament.ticketChangeAmountMustBeGreaterThanZero': '变动门票数必须大于0',
  'tournament.dayTicketDispatch': '每日，全部会员派发',
  'tournament.dayTicketDispatchTickets': '张门票',
  'tournament.rankLimitSwitch': '名次上限机制开关',
  'tournament.robotRankLimitError': '开启名次上限机制，必须开启机器人开关',

  'tournament.lobbyId': '大厅ID',
  'tournament.roomId': '房间ID',
  'tournament.startTime': '开赛时间',
  'tournament.settleTime': '结算时间',
  'tournament.roomStatus': '房间状态',
  'tournament.roomStatusNotStarted': '未开赛',
  'tournament.roomStatusInProgress': '比赛中',
  'tournament.roomStatusFinished': '比赛结束',
  'tournament.roomStatusSettling': '结算中',
  'tournament.roomStatusSettled': '已结算',
  'tournament.participantList': '参赛名单',
  'tournament.winnerList': '中奖名单',
  'tournament.accountId': '账号ID',
  'tournament.parentAccountId': '上级账号ID',
  'tournament.deviceCode': '设备码',
  'tournament.deviceType': '设备类型',
  'tournament.loginIp': '登录IP',
  'tournament.address': '地址',
  'tournament.phoneNumber': '电话号码',
  'tournament.score': '积分',
  'tournament.rank': '名次',
  'tournament.lastLoginTime': '最后登录时间',
  'tournament.accountRegisterTime': '账号注册时间',
  'tournament.roomRegisterTime': '房间报名时间',
  'tournament.participantListExportFileName': '参赛名单_{date}',
  'tournament.winnerListExportFileName': '中奖名单_{date}',

  'tournament.password': '密码',
  'tournament.enterPassword': '请输入密码',
  'tournament.passwordRegex': ' 1-10位字母数字，用户需要输入正确密码后才能参与锦标赛',

  // 门票明细
  'tournament.ticketRecord': '门票明细',
  'tournament.ticketBefore': '前值',
  'tournament.ticketAfter': '后值',
  'tournament.ticketChangeValue': '变动值',
  'tournament.changeType': '变动类型',
  'tournament.changeReason': '变动原因',
  'tournament.entryCondition': '参赛条件',
  'tournament.coinRank': '金币-名次',
  'tournament.coinSplit': '金币-瓜分',
  'tournament.enterCoin': '请输入金币',
  'tournament.enterTicketCount': '请输入门票',
  'tournament.coinRange': '请输入 1-999999 的整数',
  'tournament.rake': '抽水',
  'tournament.rakeRange': '请输入 0-999999 的整数',
  'tournament.robot': '机器人',
  'tournament.realPlayer': '真人',
  'tournament.enterRank': '请输入名次',
  'tournament.totalCoin': '总金币',
  'tournament.totalCoinRange': '请输入 0-999999 的整数',
  'tournament.coinDistribution': '金币分布',
  'tournament.robotDistribution': '机器人分布',
  'tournament.robotCount': '机器人数量',
  'tournament.enterRobotCount': '请输入机器人数量',
  'tournament.rankAtLeastOne': '至少配置一个名次',
  'tournament.rankRangeOrder': '名次范围需满足：1 ≤ 起始 ≤ 结束 ＜ 下一段起始，且不超过人限',
  'tournament.rankStartAfterPrev': '起始需大于上一段结束',
  'tournament.rankEndAfterStart': '结束需大于等于起始',
  'tournament.rankExceedLimit': '名次不能超过人限',
  'tournament.coinDistOrder': '金币分布需满足：0 ≤ 最小 ≤ 最大 ≤ 总金币',
  'tournament.coinDistExceed': '名次数 × 金币上限 不能超过总金币',
  'tournament.robotCountExceed': '机器人数量不能超过该名次范围的人数',
  'tournament.robotTotalExceed': '机器人总数不能超过人限',
  'tournament.setPlayerLimitFirst': '请先填写人限',
  'tournament.rankExceedPlayerLimit': '名次数量不能超过人限',
  'tournament.roomConsumption': '房间消耗',
  'tournament.ticketUsed': '门票使用',
  'tournament.coinUsed': '金币使用',
  'tournament.coinRake': '金币抽水',
  'tournament.coinAward': '金币发放',
  'tournament.winner': '中奖',
  'tournament.participantSummary': '参赛 {participants} 人',
  'tournament.winnerSummary': '中奖 {winners} 人',
};
